import React, { useCallback } from 'react'
import { useEditorContent } from './useEditor'
import ResizableEditorContainer from '../shared/ResizableEditorContainer'

/**
 * WysiwygEditor: Dedicated component for wysiwyg content editing
 *
 * Extracted from EditorContent to provide clean separation of concerns.
 * Uses editor context for content management and centralized configuration.
 */
const WysiwygEditor = () => {
	const { content, updateWysiwyg, editorConfig } = useEditorContent()

	// 🎯 PERFORMANCE: Stable event handler using specialized updater
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLTextAreaElement>) => {
			updateWysiwyg(e.target.value)
		},
		[updateWysiwyg],
	)

	return (
		<ResizableEditorContainer minHeight={editorConfig.wysiwyg.minHeight} theme={editorConfig.wysiwyg.theme}>
			<div className="content-editor" style={{ padding: '15px', height: '100%' }}>
				<textarea
					rows={editorConfig.wysiwyg.rows}
					value={content.wysiwyg}
					onChange={handleChange}
					placeholder={editorConfig.wysiwyg.placeholder}
					style={editorConfig.wysiwyg.style}
				/>
			</div>
		</ResizableEditorContainer>
	)
}

export default WysiwygEditor
